<template>
  <div class="languages" v-if="canShowLanguagesSelector()">
    <div class="lang-selector">
      <label class="sr-only" for="select_lang">{{ $t('header.availabilityAdjust.changeLanguage') }}</label>
      <select name="langs" id="select_lang" v-model="selectedLang">
        <option v-for="(lang, index) in languagesList" :value="lang" :selected="isLanguageActive(lang)" :key="index">
          {{ getLangLabel(lang) }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import { LANGUAGES_LABEL_LIST } from '@/base/const/lang.const'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'Languages',
  data() {
    return {
      selectedLang: null,
    }
  },
  computed: {
    ...mapGetters({
      languagesList: 'getAvailableLanguagesList',
    }),
    ...mapState({
      storeCurrentLang: (state) => state.lang.current,
    }),
  },
  watch: {
    storeCurrentLang: {
      immediate: true,
      handler(newValue) {
        if (newValue !== this.selectedLang) {
          this.selectedLang = newValue
        }
      },
    },
    selectedLang(newValue, oldValue) {
      if (oldValue && newValue !== this.storeCurrentLang) {
        this.setLanguage(newValue)
      }
    },
  },
  methods: {
    ...mapActions(['setLanguage']),

    isLanguageActive(lang) {
      return lang === this.selectedLang
    },
    getLangLabel(lang) {
      return LANGUAGES_LABEL_LIST[lang]
    },
    canShowLanguagesSelector() {
      return this.languagesList.length > 1
    },
  },
}
</script>
